const CLIENT_ROLE_ROUTE_KEY = 'clientRoleRoute';
const CLIENT_ROLE_NAME_KEY = 'clientRoleName';

/** Maps API role_name (e.g. Super-Admin) to URL prefix (e.g. super-admin). */
export function roleNameToRoutePrefix(
  roleName: string | null | undefined
): string {
  if (!roleName?.trim()) {
    return '';
  }
  return roleName.trim().toLowerCase().replace(/\s+/g, '-');
}

export function persistClientRoleRoute(
  roleName: string | null | undefined
): void {
  const prefix = roleNameToRoutePrefix(roleName);
  if (prefix) {
    sessionStorage.setItem(CLIENT_ROLE_ROUTE_KEY, prefix);
  }
  if (roleName?.trim()) {
    sessionStorage.setItem(CLIENT_ROLE_NAME_KEY, roleName.trim());
  }
}

export function getStoredClientRoleName(): string | null {
  return sessionStorage.getItem(CLIENT_ROLE_NAME_KEY);
}

/**
 * Route prefix for navigation (admin, super-admin, client, …).
 * Uses in-memory clientRole, then sessionStorage, then current URL.
 */
export function getClientRoleRoutePrefix(
  clientRole?: string | null,
  currentPath?: string
): string {
  const fromRole = roleNameToRoutePrefix(clientRole);
  if (fromRole) {
    return fromRole;
  }

  const stored = sessionStorage.getItem(CLIENT_ROLE_ROUTE_KEY);
  if (stored) {
    return stored;
  }

  const path = currentPath ?? '';
  const segment = path.split('?')[0].split('#')[0].split('/').filter(Boolean)[0];
  if (
    segment &&
    segment !== 'forbidden' &&
    segment !== 'fourzerofour'
  ) {
    return segment;
  }

  return 'admin';
}
